import Vue from "vue";

// 引入Element UI: 分页语言国际化
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 引入中文语言包
import ElementLocale from "element-ui/lib/locale";
import zhCN from "element-ui/lib/locale/lang/zh-CN";
// 引入英文语言包
import en from "element-ui/lib/locale/lang/en";
// 在Vue中使用Element UI
Vue.use(ElementUI);
// 设置默认语言为英文
ElementLocale.use(en);

export function switchLanguage(lang) {
  switch (lang) {
    case "zh":
      ElementLocale.use(zhCN);
      break;
    case "en":
      ElementLocale.use(en);
      break;
    // 你可以添加更多的语言支持
    default:
      ElementLocale.use(en);
  }
}



// WEBPACK FOOTER //
// ./src/api/sigen/paginationLang.js